// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSortDescendingOutlinedSvg from "@fishx/icons-svg/es/asn/PSortDescendingOutlined";
import FishxIcon from '../components/FishxIcon';

var PSortDescendingOutlined = function PSortDescendingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSortDescendingOutlinedSvg
  }));
};

PSortDescendingOutlined.displayName = 'PSortDescendingOutlined';
export default React.forwardRef(PSortDescendingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSortDescendingOutlined.js
// module id = 3652
// module chunks = 0